import { z } from 'zod';

export const PolicyChangeStatusRequest = z.object({
  status: z.string().min(1),
});

export type PolicyChangeStatus = z.infer<typeof PolicyChangeStatusRequest>;
